import React, { useEffect, useRef, useState } from "react";
import { loadingMessages } from "../../../../../../../src/utils/utlis.js";

const LoadingGenerationComponent = ({ generate }) => {
  const [currentMessage, setCurrentMessage] = useState("");
  const [animateKey, setAnimateKey] = useState(0); // used to restart CSS animation
  const intervalRef = useRef(null);

  useEffect(() => {
    // helper to pick a random message and restart animation
    const pickMessage = () => {
      const randomMessage = loadingMessages[Math.floor(Math.random() * loadingMessages.length)];
      setCurrentMessage(randomMessage);
      // bump key to restart CSS animation (if using animation that doesn't auto-restart)
      setAnimateKey((k) => k + 1);
    };

    if (generate) {
      // immediately show a random message (no initial blank)
      pickMessage();

      // then continue every 2s
      intervalRef.current = setInterval(() => {
        pickMessage();
      }, 3000);
    } else {
      // stopped generating -> clear interval and empty the message (optional)
      clearInterval(intervalRef.current);
      intervalRef.current = null;
      setCurrentMessage("");
    }

    // cleanup on unmount or when generate toggles
    return () => {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    };
  }, [generate]);

  return (
    <div
      /* key is used to re-run animation if using CSS animation tied to key change */
      key={animateKey}
      className="loading-message"
      aria-live="polite"
    >
      {currentMessage}
    </div>
  );
};

export default LoadingGenerationComponent;
